export default "__VITE_ASSET__CJW5dBwP__"